import ownerCustomersComponent from './owner-customers.component';

const ownerCustomersModule = angular.module('ownerCustomers', [
])
  .component('ownerCustomers', ownerCustomersComponent)
  .name;

export default ownerCustomersModule;
